// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicInput_container__ig8A_","label":"BasicInput_label__wXBOY","input":"BasicInput_input__x5OY_","errors":"BasicInput_errors__UzSps"};